import FetchRequest from "@/api/FetchRequest";
class modelroomApi {
    
    static modelAll(): Promise<any> {
      
        return FetchRequest.get('/ai/chat_model/all' ,true, false);
    }
    // 修改聊天室
    //基础url
    static url = "/vim/chatgpt";
    static editRoom(chatId:string,model: string,modelId:number): Promise<any> {
        const data={
            chatId:chatId,
            model:model,
            modelId:modelId
        }
        return FetchRequest.put(this.url,JSON.stringify(data) , true);
    }

    
}
export default modelroomApi;